/** Marks the element merchant CSS is confined to when previewed in-app. */
export const CSS_SCOPE_ATTRIBUTE = "data-redo-css-scope";

/** `useId()` values contain `:`, which an attribute selector can't carry raw. */
export function cssScopeToken(id: string): string {
  return id.replace(/[^a-zA-Z0-9_-]/g, "");
}

/** An unterminated comment runs to end-of-input per the CSS spec, so `$` closes
 *  it here too — braces the browser never sees must not be counted. */
function stripCommentsAndStrings(css: string): string {
  return css
    .replace(/\/\*[\s\S]*?(?:\*\/|$)/g, "")
    .replace(/"(?:[^"\\\n]|\\.)*"/g, '""')
    .replace(/'(?:[^'\\\n]|\\.)*'/g, "''");
}

export function hasBalancedBraces(css: string): boolean {
  let depth = 0;
  for (const character of stripCommentsAndStrings(css)) {
    if (character === "{") {
      depth++;
    } else if (character === "}" && --depth < 0) {
      return false;
    }
  }
  return depth === 0;
}

/** Confines merchant CSS to the card on surfaces outside the storefront's
 *  shadow root. Empty on unbalanced braces, which would leak past the wrapper. */
export function scopeCustomCss(css: string, scopeToken: string): string {
  const trimmed = css.trim();
  if (!trimmed || !hasBalancedBraces(trimmed)) {
    return "";
  }
  return `@scope ([${CSS_SCOPE_ATTRIBUTE}="${scopeToken}"]) {\n${trimmed}\n}`;
}
